import { register } from 'register-service-worker'
import { basePath } from '@/router/location-params'
import { useLogger } from '@booksy-com/vue-tools'

export function registerServiceWorker (): void {
  const logger = useLogger('service-worker')

  if (process.env.NODE_ENV === 'production') {
    logger.debug('registering service worker')

    register(`${window.location.origin}${basePath}/service-worker.js`, {
      ready () {
        logger.debug(
          'App is being served from cache by a service worker.\n'
          + 'For more details, visit https://goo.gl/AFskqB'
        )
      },
      registered () {
        logger.debug('Service worker has been registered.')
      },
      cached () {
        logger.debug('Content has been cached for offline use.')
      },
      updatefound () {
        logger.debug('New content is downloading.')
      },
      updated () {
        logger.debug('New content is available; please refresh.')
      },
      offline () {
        logger.debug('No internet connection found. App is running in offline mode.')
      },
      error (error: Error) {
        logger.debug('Error during service worker registration:', error)
      },
    })
  }
}
